export default __webpack_public_path__ + "static/media/circle-arrow-left-curved.7d5b43bd.svg";